import { createAsyncThunk } from "@reduxjs/toolkit";
import { LogsList } from "../../../mock/DigitalMarketing/customerList";
import { getCustomerApi, getCustomer_contact } from "../../../Service/api/ApiUrls";
import axios from '../../../Service/axios'

export const GetcustomerLogs = createAsyncThunk(
  `customer/logslist`,
  async (data :any) => {
    var val = LogsList
    if(data !== null){
       val = [...LogsList,data]
    }
    
    return val;
  }
);

export const GetCustomerContact = createAsyncThunk(
  `customer/contact`,
  async (id :any) => {
    const res = axios.get(`${getCustomer_contact}/${id}`);
    return res;
  }
);

export const GetCustomerDetail = createAsyncThunk(
  `customer/detail`,
  async (id :any) => {
    const res = axios.get(`${getCustomerApi}/${id}`);
    return res;
  }
);

export const UpdateCustomerDetail = createAsyncThunk(
  `customer/detail/update`,
  async (id :any,data:any) => {
    const res = axios.put(`${getCustomerApi}/${id}`,data);
    return res;
  }
);